app.service('bottomBar',function() {
	function init(){

	}
	return {
		init
	};
});
